import React from 'react';
import {View} from 'react-native';
import { MarketComponents } from 'be-components';
import { useDispatch, useSelector } from 'react-redux';
import { BestAvailableOrderProps, EventOrderStatProps, TradeProps } from '../store/types/mk_svc';
import { PlayerPremiumItem } from '../store/types/auth_svc';
import { market_setDraftOrder } from '../store/actionsv1/markets';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../store/actionsv1/types';
import { EventProps } from '../store/types/sr_svc';

type EventMarketHolderProps = {
    event_id:string,
    market_id:string,
    navigation:any
}

const EventMarketHolder = ({ event_id, market_id, navigation}:EventMarketHolderProps) => {
    const dispatch = useDispatch();
    const event:EventProps|undefined = useSelector((state:any) => state.event.events[event_id], (left, right) => left == right);
    const market = useSelector((state:any) => state.market.markets.find(m => m.market_id == market_id), (left, right) => left?.market == right?.market);

    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const latest_trades:TradeProps[] = useSelector((state:any) => state.market.latest_trades[`team:${event_id}`], (left, right) => left == right) ?? [];
    const event_trades = latest_trades.filter(t => t.market_id == market_id && t.market_type == 'FOR_MONEY');
    
    const best_available:BestAvailableOrderProps[] = useSelector((state:any) => state.market.best_available[`team:${event_id}`], (left, right) => left == right) ?? []
    const event_best_available = best_available.filter(o => o.market_id == market_id);
    
    const order_stats:EventOrderStatProps[] = useSelector((state:any) => state.market.order_stats[`team:${event_id}`], (left, right) => left == right) ?? [];
    const event_order_stats = order_stats.filter(s => s.market_id == market_id && s.market_type == 'FOR_MONEY')

    const premium_grades = useSelector((state:any) => state.player.player_premium_items_list.player_premium_items.find((ppi:PlayerPremiumItem) => ppi.premium_item?.identifier == 'order_grades'), (left, right) => left?.last_update_datetime == right?.last_update_datetime);
    

    if(!event || !market){ return <></> }

    let show_grades = false
    if(player?.type == 'premium' || premium_grades){ show_grades = true }
    return (
        <View>
            <MarketComponents.EventMarket
                event={{ ...event, over:{abbr:'Over'}, under:{abbr:'Under'}, yes:{abbr:'Yes'}, no:{abbr:'No'}, heads:{abbr:'Heads'}, tails:{abbr:'Tails'} }}
                default_price_view='best_available'
                show_grades={show_grades}
                market={market}
                hide_liquidity
                latest_trades={event_trades}
                event_order_stats={event_order_stats}
                best_available_orders={event_best_available}
                onOrder={(order) => dispatch(market_setDraftOrder(order))}
                onView={(d) => navigation.navigate('EventStack', { screen:'Market', initial:false, params: { event_id:d.event_id, event_type: d.event_type, market_id: d.market_id, participant_type:d.side_type, participant_id:d.side_id }} )}
                onTradeLongPress={(trade:TradeProps) => {
                    dispatch({ 
                        type: V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
                        external_price_comparison: {
                            event_id:trade.event_id,
                            event_type:trade.event_type,
                            init_market:trade.market,
                            side: trade.side,
                            participant_id: trade.market?.level == 'event' ? undefined : trade.side_id,
                            participant_type: trade.market?.level == 'event' ? undefined : trade.side_type
                        } 
                    })
                }}            />
        </View>
    )
}

export default EventMarketHolder